/**
 * @copyright Copyright (c) Agence ink
 */

//// Module summary ////
// => This module contains the JS required by the menu to appear and animate properly

/////////////// GSAP animation modules (Uncomment required gsap library!) /////////////////
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger"; gsap.registerPlugin(ScrollTrigger);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import ScrollToPlugin from "gsap/ScrollToPlugin"; gsap.registerPlugin(ScrollToPlugin);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
// import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
///////////////////////////////////////////////////////////////////////////////////////////

export const menu = () => {
  
    let menu = document.querySelector(".menu");
    if (menu) {
        // Variables
        let links = menu.querySelectorAll(".menu-link");
        let buttons = menu.querySelectorAll(".menu-btn");
        let menuOpen = document.querySelector('[data-gsap="menu"]');
        let menuClose = menu.querySelector(".close");
    
        // == Timeline ==
        // A) Prevent document scroll
        // B) Reel down the menu
        // C) Pull the links up      
        // D) Show buttons
        let TL_MENU = gsap.timeline({
            paused: true
        });
        
        // A) Prevent document scroll
        TL_MENU.set(document.body, {
            overflow: "hidden"
        })
        
        // B) Reel the menu down
            .to(menu, {
                y: 0,
                duration: 0.5,
                ease: "power3"
            })
        // C) Pull the links up
            .to(links, {
                y: 0,
                autoAlpha: 1,
                duration: 0.5,
                stagger: 0.125
            }, "<+=0.125")
        // D) Show buttons
            .to(buttons, { autoAlpha: 1 }, "<+=.25");
        
        // Open on click
        menuOpen.addEventListener("click", () => {
            TL_MENU.timeScale(1).play();
        });
        // Revert to close, but faster
        menuClose.addEventListener("click", () => {
            TL_MENU.timeScale(1.75).reverse();
        });
    }
    return;
}
